<template>
  <div class="global-hdr">
    <div class="title"><h1>全国直轄国道維持管理データベース</h1></div>

    <div class="right-container">
      <div v-if="!isError" class="user">{{ userInfo }}</div>
      <button v-if="!isError" @click="logout" class="bt bt-logout">
        ログアウト
      </button>
    </div>
  </div>
</template>

<script>
import { responseParm } from "@/js/commonConst";
export default {
  name: "CommonHeader",
  components: {},
  data() {
    return {
      logoutParams: {
        userId: "",
      },
    };
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // ヘッダーに表示するユーザー名取得
    userInfo() {
      const userName = sessionStorage.getItem("SesUserName") || "";
      return `${userName}`;
    },
  },
  methods: {
    logout() {
      this.hundleLogout();
    },
    // ログアウト処理API
    hundleLogout() {
      this.logoutParams = {
        userId: sessionStorage.getItem("SesUserId"),
      };
      this.$httpUtil.post("/logout", this.logoutParams, (data) => {
        if (
          data.code === responseParm.REQUEST_CODE_200 &&
          data.result === responseParm.REQUEST_RESPONSE_0
        ) {
          sessionStorage.clear();
          this.$emit("logout");
          this.$router.push("/login");
        } else {
          sessionStorage.clear();
          this.$emit("logout");
          this.$router.push("/login");
        }
      });
    },
    // ダミーログアウト処理
    dummyHundleLogout() {
      sessionStorage.clear();
      this.$emit("logout");
      this.$router.push("/login");
    },
  },
};
</script>
